var collapsible_list_pair_default = {
  "container": "MdgjC",
  "title": "saT1G",
  "viewerContainer": "xc1t1",
  "titleContainer": "-RHuh",
  "expandIcon": "vNq4N",
  "dndIcon": "EK5HN",
  "RTL": "lX5ml",
  "LTR": "kUmxq",
  "itemContainer": "_5Glhq",
  "itemContainerViewer": "ob--J",
  "mouseDown": "ov079",
  "innerEditor": "SxrxQ",
  "item": "h2m6S",
  "floatingAddPluginMenuWrapper": "_0z72V",
  "childrenHidden": "rwiUi"
};
export {
  collapsible_list_pair_default as default
};
//# sourceMappingURL=collapsible-list-pair-scss.js.map
